window.theme.block('listing-ofertas', el => {
	const grid = el.querySelector('.js-offer-grid');
	const sentinel = el.querySelector('.js-scroll-sentinel');
	const loader = el.querySelector('.js-offer-loader');
	const filtersTrigger = el.querySelector('.js-offer-filters-trigger');
	const filtersSheet = el.querySelector('.js-offer-filters-sheet');
	const filtersSheetClose = el.querySelector('.js-offer-filters-sheet-close');
	const filtersSheetBackdrop = el.querySelector('.js-offer-filters-sheet-backdrop');

	if (!grid) return;

	// Delegated so it also works on page-break markers appended later by
	// fetchOffers()/appendOfferItems(), not just the ones rendered on load.
	el.addEventListener('click', event => {
		const trigger = event.target.closest('.js-offer-loop-top');
		if (!trigger || !el.contains(trigger)) return;
		el.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});

	// Mobile "Filtros" action sheet: duplicates the store/sort/view controls
	// already wired below, so opening/closing it needs no state of its own.
	function openFiltersSheet() {
		if (!filtersSheet) return;
		filtersSheet.classList.add('is-open');
		filtersSheet.hidden = false;
		document.body.classList.add('has-offer-filters-sheet-open');
		if (filtersTrigger) filtersTrigger.setAttribute('aria-expanded', 'true');
	}

	function closeFiltersSheet() {
		if (!filtersSheet || !filtersSheet.classList.contains('is-open')) return;
		filtersSheet.classList.remove('is-open');
		filtersSheet.hidden = true;
		document.body.classList.remove('has-offer-filters-sheet-open');
		if (filtersTrigger) filtersTrigger.setAttribute('aria-expanded', 'false');
	}

	if (filtersTrigger) filtersTrigger.addEventListener('click', openFiltersSheet);
	if (filtersSheetClose) filtersSheetClose.addEventListener('click', closeFiltersSheet);
	if (filtersSheetBackdrop) filtersSheetBackdrop.addEventListener('click', closeFiltersSheet);
	document.addEventListener('keydown', event => {
		if (event.key === 'Escape') closeFiltersSheet();
	});

	let paged = parseInt(grid.dataset.paged, 10) || 1;
	let maxPages = parseInt(grid.dataset.maxPages, 10) || 1;
	let loading = false;

	// On search.php the grid is the search results themselves: filters must
	// narrow the current search instead of navigating to a store/category
	// archive (which would silently drop the search term).
	const isSearchMode = grid.dataset.isSearch === '1';
	const searchTerm = new URL(window.location.href).searchParams.get('s') || '';

	const VIEW_STORAGE_KEY = 'pechincha_view_preference';
	// Matches the 'phone' breakpoint token (768px) used across the theme's SCSS.
	const DESKTOP_MEDIA_QUERY = '(min-width: 48rem)';

	function getStoredView() {
		try {
			const stored = window.localStorage.getItem(VIEW_STORAGE_KEY);
			return allowedViews.includes(stored) ? stored : '';
		} catch (error) {
			return '';
		}
	}

	function storeView(view) {
		try {
			window.localStorage.setItem(VIEW_STORAGE_KEY, view);
		} catch (error) {
			// Ignore (private browsing, storage disabled, etc.) — the toggle
			// still works for the current page view.
		}
	}

	const allowedViews = ['grid', 'list'];

	const state = {
		loja: grid.dataset.loja || '',
		ordem: grid.dataset.ordem || 'recent',
		categoria: grid.dataset.categoria || '',
		view: grid.dataset.view || 'list',
	};
	if (!allowedViews.includes(state.view)) {
		state.view = 'list';
	}

	// No explicit user choice saved yet: pick the default by device instead of
	// always trusting the SSR 'list' default, which is list-first only so
	// no-JS visitors still get a sane layout.
	const storedView = getStoredView();
	if (storedView) {
		state.view = storedView;
	} else if (window.matchMedia && window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
		state.view = 'grid';
	}

	function getStoreBaseUrl(storeSlug) {
		if (!storeSlug) return '';
		const button = el.querySelector(`.js-offer-filter-btn[data-loja="${storeSlug}"]`);
		return button ? (button.dataset.url || '') : '';
	}

	function getCategoryBaseUrl(categorySlug) {
		if (!categorySlug) return '';
		const link = el.querySelector(`.js-offer-category-link[data-categoria="${categorySlug}"]`);
		return link ? (link.dataset.baseUrl || '') : '';
	}

	function normalizePath(path) {
		if (!path) return '/';
		return path.startsWith('/') ? path : `/${path}`;
	}

	// The category picker never renders in search mode (see listing-ofertas.php),
	// so these selectors simply match nothing there — no search-mode branching
	// needed here.
	function syncCategoryLinks() {
		const allLink = el.querySelector('.js-offer-category-link[data-home-url]');
		if (allLink) {
			const homeUrl = allLink.dataset.homeUrl || '/';
			const currentStoreUrl = getStoreBaseUrl(state.loja);
			allLink.setAttribute('href', state.loja ? currentStoreUrl || homeUrl : homeUrl);
		}

		el.querySelectorAll('.js-offer-category-link[data-base-url]').forEach(link => {
			const baseUrl = link.dataset.baseUrl || '';
			if (!baseUrl) return;
			const nextUrl = new URL(baseUrl, window.location.origin);
			nextUrl.searchParams.delete('loja');
			if (state.loja) {
				nextUrl.searchParams.set('loja', state.loja);
			}
			link.setAttribute('href', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
		});
	}

	function buildUrl(nextState) {
		const currentUrl = new URL(window.location.href);
		const params = new URLSearchParams(currentUrl.search);
		let pathname = currentUrl.pathname;

		params.delete('loja');
		params.delete('ordem');
		params.delete('oferta_page');
		params.delete('view');
		params.delete('categoria');

		// In search mode, stay on the search results page: pathname is never
		// swapped for a store/category archive, which has no search term of
		// its own and would drop it.
		if (!isSearchMode) {
			if (nextState.loja && !nextState.categoria) {
				const storeUrl = getStoreBaseUrl(nextState.loja);
				if (storeUrl) {
					pathname = new URL(storeUrl, window.location.origin).pathname;
				}
			}

			if (!nextState.loja && nextState.categoria) {
				const categoryUrl = getCategoryBaseUrl(nextState.categoria);
				if (categoryUrl) {
					pathname = new URL(categoryUrl, window.location.origin).pathname;
				}
			}

			if (!nextState.loja && !nextState.categoria) {
				pathname = normalizePath(grid.dataset.homePath || '/');
			}
		}

		if (nextState.loja && !pathname.includes('/loja-oferta/')) params.set('loja', nextState.loja);
		if (nextState.ordem && nextState.ordem !== 'recent') params.set('ordem', nextState.ordem);
		if (nextState.paged > 1) params.set('oferta_page', `${nextState.paged}`);
		if (nextState.view && nextState.view !== 'list') params.set('view', nextState.view);
		if (nextState.categoria && !pathname.includes('/categoria-oferta/')) params.set('categoria', nextState.categoria);

		const queryString = params.toString();
		return queryString ? `${pathname}?${queryString}` : pathname;
	}

	function setLoaderVisibility(show) {
		if (!loader) return;
		loader.classList[show ? 'remove' : 'add']('hidden');
	}

	function updateSentinelVisibility() {
		if (!sentinel) return;
		sentinel.classList[paged >= maxPages ? 'add' : 'remove']('hidden');
	}

	function updateActiveControls() {
		el.querySelectorAll('.js-offer-filter-btn').forEach(button => {
			const isActive = (button.dataset.loja || '') === state.loja;
			button.classList.toggle('style-primary', isActive);
		});

		el.querySelectorAll('.js-offer-sort-btn').forEach(button => {
			const isActive = (button.dataset.ordem || 'recent') === state.ordem;
			button.classList.toggle('is-active', isActive);
		});

		el.querySelectorAll('.js-offer-view-btn').forEach(button => {
			const isActive = (button.dataset.view || 'grid') === state.view;
			button.classList.toggle('is-active', isActive);
		});
	}

	function applyViewMode() {
		grid.classList.remove('is-view-grid', 'is-view-list');
		grid.classList.add(`is-view-${state.view}`);
		grid.dataset.view = state.view;

		const loop = grid.querySelector('.component-offer-loop');
		if (loop) {
			loop.classList.remove('is-view-grid', 'is-view-list');
			loop.classList.add(`is-view-${state.view}`);
		}

		grid.querySelectorAll('.component-offer-card').forEach(card => {
			card.classList.remove('is-view-grid', 'is-view-list');
			card.classList.add(`is-view-${state.view}`);
		});
	}

	// A <script> tag inside appended HTML never runs on its own (true whether
	// it arrives via appendChild of parsed nodes or insertAdjacentHTML), and
	// an AdSense <ins class="adsbygoogle"> never fills without an explicit
	// (adsbygoogle = window.adsbygoogle || []).push({}) call per unit. This
	// is the idiom AdSense itself documents for ad units inserted after page
	// load (infinite scroll, tabs, etc.) — queues safely even before the real
	// adsbygoogle.js script (or none at all, e.g. pre-consent) has loaded.
	function requestAdsenseFillFor(container) {
		container.querySelectorAll('ins.adsbygoogle').forEach(() => {
			(window.adsbygoogle = window.adsbygoogle || []).push({});
		});
	}

	function appendOfferItems(html) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		const incomingLoop = doc.querySelector('.component-offer-loop');
		const currentLoop = grid.querySelector('.component-offer-loop');

		if (!currentLoop || !incomingLoop) {
			grid.insertAdjacentHTML('beforeend', html);
			requestAdsenseFillFor(grid);
			return;
		}

		const nodes = Array.from(incomingLoop.children);
		nodes.forEach(node => {
			currentLoop.appendChild(node);
			requestAdsenseFillFor(node);
		});
	}

	// The nonce baked into the page at render time goes stale after its
	// lifetime (a tab left open a long time, or a cached HTML page serving an
	// old one to everyone): ask the server for a fresh one instead of leaving
	// pagination silently broken until a full reload.
	async function refreshOffersNonce() {
		try {
			const formData = new FormData();
			formData.append('action', 'pechincha_refresh_offers_nonce');
			const response = await fetch(config.ajax_url, {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
			});
			const result = await response.json();
			if (result.success && result.data && result.data.nonce) {
				grid.dataset.nonce = result.data.nonce;
				return true;
			}
		} catch (error) {
			console.error('Erro ao renovar nonce de ofertas:', error);
		}
		return false;
	}

	// One real network attempt; a stale-nonce response triggers exactly one
	// nonce refresh + retry before giving up, so this can't loop forever.
	async function postLoadOffers(nextPaged) {
		const formData = new FormData();
		formData.append('action', 'pechincha_load_offers');
		formData.append('nonce', grid.dataset.nonce || '');
		formData.append('paged', `${nextPaged}`);
		formData.append('loja', state.loja);
		formData.append('ordem', state.ordem);
		formData.append('categoria', state.categoria);
		formData.append('view', state.view);
		formData.append('s', searchTerm);

		const response = await fetch(config.ajax_url, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin',
		});
		return response.json();
	}

	async function fetchOffers(nextPaged, replaceContent) {
		if (loading) return;

		loading = true;
		setLoaderVisibility(true);

		try {
			let result = await postLoadOffers(nextPaged);

			if (!result.success && result.data && result.data.code === 'invalid_nonce' && (await refreshOffersNonce())) {
				result = await postLoadOffers(nextPaged);
			}

			if (!result.success || !result.data) return;

			const html = result.data.html || '';
			if (replaceContent) {
				grid.innerHTML = html;
				requestAdsenseFillFor(grid);
			} else {
				appendOfferItems(html);
			}

			paged = nextPaged;
			maxPages = parseInt(result.data.max_pages, 10) || maxPages;

			grid.dataset.paged = `${paged}`;
			grid.dataset.maxPages = `${maxPages}`;
			grid.dataset.loja = state.loja;
			grid.dataset.ordem = state.ordem;
			grid.dataset.categoria = state.categoria;
			grid.dataset.view = state.view;
			applyViewMode();

			updateSentinelVisibility();

			const historyState = {
				paged,
				loja: state.loja,
				ordem: state.ordem,
				categoria: state.categoria,
				view: state.view,
			};
			const nextUrl = buildUrl(historyState);
			window.history.pushState(historyState, '', nextUrl);
		} catch (error) {
			console.error('Erro no carregamento das ofertas:', error);
		} finally {
			loading = false;
			setLoaderVisibility(false);
		}
	}

	function applyFilter(nextStore) {
		state.loja = nextStore;
		paged = 1;
		updateActiveControls();
		fetchOffers(1, true);
		closeFiltersSheet();
	}

	function applySort(nextSort) {
		state.ordem = nextSort;
		paged = 1;
		updateActiveControls();
		fetchOffers(1, true);
		closeFiltersSheet();
	}

	function applyView(nextView) {
		if (!allowedViews.includes(nextView)) return;
		state.view = nextView;
		storeView(nextView);
		updateActiveControls();
		applyViewMode();

		const historyState = {
			paged,
			loja: state.loja,
			ordem: state.ordem,
			categoria: state.categoria,
			view: state.view,
		};
		const nextUrl = buildUrl(historyState);
		window.history.pushState(historyState, '', nextUrl);
		syncCategoryLinks();
		closeFiltersSheet();
	}

	el.addEventListener('click', event => {
		const filterButton = event.target.closest('.js-offer-filter-btn');
		if (filterButton && el.contains(filterButton)) {
			event.preventDefault();
			applyFilter(filterButton.dataset.loja || '');
			return;
		}

		const sortButton = event.target.closest('.js-offer-sort-btn');
		if (sortButton && el.contains(sortButton)) {
			event.preventDefault();
			applySort(sortButton.dataset.ordem || 'recent');
			return;
		}

		const viewButton = event.target.closest('.js-offer-view-btn');
		if (viewButton && el.contains(viewButton)) {
			event.preventDefault();
			applyView(viewButton.dataset.view || 'grid');
		}
	});

	if (sentinel) {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting && !loading && paged < maxPages) {
					fetchOffers(paged + 1, false);
				}
			});
		}, { rootMargin: '200px' });

		observer.observe(sentinel);
	}

	window.addEventListener('popstate', event => {
		if (event.state) {
			window.location.reload();
		}
	});

	updateActiveControls();
	applyViewMode();
	syncCategoryLinks();
	updateSentinelVisibility();
});